import { getApiUrl } from "@app/shared";
import { useEffect, useState } from "react";

/**
 * Probe the target-photo endpoint to determine whether a photo exists for the
 * given target. The `hasPhoto` flag on Target is no longer back-filled, so
 * callers must verify by attempting to load the image.
 *
 * Returns the photo URL and a boolean indicating whether the image loaded
 * successfully. The URL is empty when any required identifier is missing.
 */
export function useTargetPhoto(
    externalTargetId: string | undefined,
    deviceId: string | undefined,
    organizationId: string | undefined,
): { photoUrl: string; hasPhoto: boolean } {
    const photoUrl = externalTargetId && deviceId && organizationId
        ? getApiUrl(`/api/organization/${organizationId}/device/${deviceId}/target/${externalTargetId}/photo`)
        : "";

    const [hasPhoto, setHasPhoto] = useState(false);

    useEffect(() => {
        setHasPhoto(false);
        if (!photoUrl) return;
        let cancelled = false;
        const img = new Image();
        img.onload = () => { if (!cancelled) setHasPhoto(true); };
        img.onerror = () => { if (!cancelled) setHasPhoto(false); };
        img.src = photoUrl;
        return () => { cancelled = true; };
    }, [photoUrl]);

    return { photoUrl, hasPhoto };
}
